// ProductDeleteConfirmModal Component
// Confirmation modal for deleting products

import React from 'react';
import { RevoltModal } from '../../../../../components/RevoltModal';
import { RevoltButton } from '../../../../../components/RevoltButton';
import './ProductDeleteConfirmModal.css';

export function ProductDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  product = null,
  isLoading = false
}) {
  if (!product) {
    return null;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Product"
      showCloseButton={true}
    >
      <div className="product-delete-confirm-content">
        <p className="product-delete-confirm-message">
          Are you sure you want to delete the product &quot;{product.name || 'Unnamed Product'}&quot;? This action cannot be undone.
        </p>
        <div className="product-delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete Product'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default ProductDeleteConfirmModal;
